module.exports = __webpack_public_path__ + "static/media/BILLET.0630677b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/BILLET.svg
// module id = 75
// module chunks = 0